import { memo } from "react";
import FormTextField from "../FormTextField";

interface POIItemDetaiAudioProps {
    name: string;
}

function POIItemDetaiAudio({ name }: POIItemDetaiAudioProps) {
    return (
        <div>
            <FormTextField
                sx={{ mt: 1 }}
                fullWidth
                label="URL"
                variant="outlined"
                name={`${name}.url`}
            />
        </div>
    );
}

export default memo(POIItemDetaiAudio);
